import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import useWorkspaceStore from "../../../../store/workspace/workspaceStore";
import HealthScoreChatBuilder from "./components/HealthScoreChatBuilder";

const HealthScoreModelBuilderPage: React.FC = () => {
  const navigate = useNavigate();
  const { workspaceId: workspaceSlugParam } = useParams();
  const workspace = useWorkspaceStore((state) => state.workspace);

  const handleBack = () => {
    const workspaceSlug = workspace?.unique_identifier || workspaceSlugParam || "";
    navigate(`/home/${workspaceSlug}/settings/health-score`);
  };

  return (
    <div className="h-full min-h-[640px]">
      <HealthScoreChatBuilder onBack={handleBack} />
    </div>
  );
};

export default HealthScoreModelBuilderPage;
